<template>
  <!-- 固定资产盘点 -->
  <div class="IA_fixedAssetInventory"
       :style="{
      '--header_fontsize':
        (pageinfo.header_fontsize ? pageinfo.header_fontsize : 14) + 'px',
      '--header_isbold': pageinfo.header_isbold ? 'bold' : 'unset'
    }">
    <van-nav-bar :title="'固定资产盘点'"
                 left-text
                 left-arrow
                 @click-left="onClickLeft"
                 :fixed="true" />
    <div class="content">
      <van-tabs v-model="activeName"
                @change="changeActive">
        <van-tab title="盘点中"
                 name="a"></van-tab>
        <van-tab title="未盘点"
                 name="b"></van-tab>
        <van-tab title="已盘点"
                 name="c"></van-tab>
      </van-tabs>
      <div class="table_content">
        <ve-table :columns="thList"
                  border-y
                  :table-data="tableData"
                  :footer-data="totalData"
                  :scrollWidth="scrollWidth"
                  :style="
            tableData.length == 0
              ? 'height:100px;'
              : 'height: 100%;' + 'width:100%;word-break:break-word'
          "
                  max-height="100%"
                  :cell-span-option="cellSpanOption"
                  :cell-style-option="cellStyleOption" />
        <div v-show="tableData.length == 0"
             class="empty-data"
             style="font-size:16px;text-align: center">
          暂无数据
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入组件库
import { VeTable } from 'vue-easytable' // VePagination, VeIcon, VeLoading, VeLocale
import { getHrQueryPageInfoRawJson, getFixedAssetsPdMaster } from '@api/wx.js'
export default {
  components: {
    VeTable
  },
  data () {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    return {
      userInfo,
      moduleno: 1337,
      activeName: 'a',
      scrollWidth: 0,
      thList: [], // 表头列表
      tableData: [], // 表格数据
      ini: [], // 原始表格数据
      ini2: [], // 原始最后一行合计数据
      totalData: [], // 最后一行合计数据
      valueData: [], // 记录
      pageinfo: {}, // 页面配置信息
      fieldlist: [], // 字段信息
      app_fix_col_count: 0, // 表格固定多少列
      appquery_jump_btn_title: '', // 查看明细按钮文字
      appquery_jump_detail: false, // 是否显示查看明细
      appquery_jump_fieldname: '', // 查看明细参数名
      appquery_jump_moduleno: '', // 查看明细跳转模块号
      show_err_action_btn: false, // 是否显示处理异常列
      err_action_btn_caption: '', // 异常按钮标题
      merge_cell_count: 0, // 表格自动合并前n列单元格
    }
  },
  computed: {
    showAtfile () {
      let fieldnames = this.thList.map(it => {
        return it.fieldname
      })
      if (fieldnames.includes('atfileflag'))
      {
        return true
      } else
      {
        return false
      }
    },
    // 表格合并单元格
    cellSpanOption () {
      if (this.merge_cell_count > 0)
      {
        return {
          bodyCellSpan: this.mergeCells
        }
      } else
      {
        return {}
      }
    },
    // 需要合并的前n-1列的表头
    mergedLeftFieldlist () {
      let fileds = []
      this.fieldlist.forEach((el, i) => {
        if ((i + 1) <= this.merge_cell_count && el.gridwith)
        {
          fileds.push(el.fieldname)
        }
      });
      if (fileds.length > 0)
      {
        return fileds.slice(0, -1)
      } else
      {
        return []
      }
    },
    // 需要合并的最后一列的表头
    mergedRightFieldlist () {
      let fileds = []
      this.fieldlist.forEach((el, i) => {
        if ((i + 1) <= this.merge_cell_count && el.gridwith)
        {
          fileds.push(el.fieldname)
        }
      });
      return fileds
    },
    // 添加合并单元格样式
    cellStyleOption () {
      if (this.merge_cell_count > 0)
      {
        return {
          bodyCellClass: ({ row, column, rowIndex }) => {
            if (this.mergedRightFieldlist.includes(column.field))
            {
              return 'merged-cell';
            }
          }
        }
      } else
      {
        return {}
      }
    }
  },
  watch: {
    '$route': {
      handler (n) {
        const activeName = this.$route.query.activeName
        if (activeName)
        {
          this.activeName = activeName
        }
      },
      immediate: true
    }
  },
  created () {
    this.getFixedAssetsPdMasterdata()
  },
  methods: {
    // 查看明细
    checkDetail (row) {
      // console.log(row, 'checkDetail(row)');
      this.$router.push({
        path: '/fixedAssetInventoryDetail',
        query: { autoid: row.autoid, activeName: this.activeName }
      })
    },
    // 查询固定资产盘点主记录信息
    getFixedAssetsPdMasterdata () {
      const pdstatus = this.activeName == 'a' ? '盘点中' : this.activeName == 'b' ? '未盘点' : '已盘点'
      getFixedAssetsPdMaster({
        pdstatus: pdstatus,
        username: this.userInfo.username
      }).then(res => {
        this.valueData = res.data
        this.getHrQueryPageInfo(JSON.stringify(res))
      })
    },
    // 查询构造表格信息
    getHrQueryPageInfo (jsonstr) {
      const empcode = this.userInfo.empcode
      const langid = localStorage.getItem('langid')
      getHrQueryPageInfoRawJson({
        moduleno: this.moduleno,
        empcode: empcode,
        langid: langid,
        jsonstr
      }).then(res => {
        this.fieldlist = res.fieldlist
        // this.jumplist = res.jumplist
        this.pageinfo = res.pageinfo[0]
        this.app_fix_col_count = this.pageinfo.app_fix_col_count
        this.appquery_jump_btn_title = this.pageinfo.appquery_jump_btn_title
        this.appquery_jump_detail = this.pageinfo.appquery_jump_detail
        this.appquery_jump_fieldname = this.pageinfo.appquery_jump_fieldname
        this.appquery_jump_moduleno = this.pageinfo.appquery_jump_moduleno
        this.show_err_action_btn = this.pageinfo.show_err_action_btn // 是否显示处理异常列
        this.err_action_btn_caption = this.pageinfo.err_action_btn_caption // 按钮标题
        this.merge_cell_count = this.pageinfo.merge_cell_count
        if (this.pageinfo.apptemplateid != 0)
        {
          // 用表格显示
          this.thList = JSON.parse(JSON.stringify(this.fieldlist))
          this.thList = this.thList.filter(it => {
            return it.gridwith
          })
          // 需要增加一列查看明细
          this.thList.unshift({
            showDetail: true,
            type: 'btn',
            fieldname: '',
            chnname: '操作',
            gridwith: 40,
            footerkind: 'skNone',
            appgroupname: ''
          })
          // 是否显示处理异常列
          if (this.show_err_action_btn)
          {
            this.thList.unshift({
              type: 'btn',
              fieldname: '',
              chnname: '操作',
              gridwith: 40,
              footerkind: 'skNone',
              appgroupname: ''
            })
          }
          let obj = {
            fieldname: 'serial',
            chnname: '序号',
            gridwith: this.pageinfo.sqnum_width || 25,
            footerkind: 'skNone',
            appgroupname: ''
          }
          if (this.pageinfo.sqnum_width != 0)
          {
            this.thList.unshift(obj)
          }
          // 固定多少列
          let frozenColCount = this.app_fix_col_count ? parseInt(this.app_fix_col_count + 1) : 1 // 因为手工添加了一列“序号”所以要加1
          // 如果有操作列，再加1
          if (this.show_err_action_btn)
          {
            frozenColCount = frozenColCount + 1
          }
          this.scrollWidth = 0
          this.thList.forEach((it, ii) => {
            if (ii < frozenColCount)
            {
              it.fixed = 'left'
              this.scrollWidth += it.gridwith * 2
            }
            it.title = it.chnname ? it.chnname.replace(/<br>/g, "\n") : it.chnname
            it.field = it.fieldname

            it.key = 'k' + ii
            it.width = it.gridwith * 2 //先注释掉用自适应显示
            const fieldvalue_align = it.fieldvalue_align || 'center'
            it.align = fieldvalue_align
            // 自定义单元格
            if (it.fieldname == 'atfileflag')
            {
              // 附件
              it.renderBodyCell = ({ row, column, rowIndex }, h) => {
                const url = require('@assets/img/ft_ico_fj.png')
                const bgcolor = row.v8_rgb_color_field
                  ? row.v8_rgb_color_field
                  : '#ffffff'
                const fontColor = row.v8_rgb_font_color
                  ? row.v8_rgb_font_color
                  : '#000000d9'
                const style =
                  'height: 100%; display: flex; align-items: center;width: 100%;padding:10px; background:' +
                  bgcolor +
                  ';color:' +
                  fontColor +
                  ';'
                if (this.showAtfile && row.atfileflag == 1)
                {
                  return (
                    <div
                      style={style}
                      on-click={() => {
                        // console.log(row, 'rowrow');
                        if (row.module_file_url)
                        {
                          window.open(row.module_file_url)
                        }
                      }}
                    >
                      <img src={url} alt="" style="width:19px;height:18px;" />
                    </div>
                  )
                } else
                {
                  return <div style={style}></div>
                }
              }
            } else if (it.fielddatatype == 'bit')
            {
              // 布尔类型
              it.renderBodyCell = ({ row, column, rowIndex }, h) => {
                const text = row[column.field]
                const bgcolor = row.v8_rgb_color_field
                  ? row.v8_rgb_color_field
                  : '#ffffff'
                const fontColor = row.v8_rgb_font_color
                  ? row.v8_rgb_font_color
                  : '#000000d9'
                const style =
                  'height: 100%; display: flex; align-items: center; justify-content: center;width: 100%;padding:10px; background:' +
                  bgcolor +
                  ';color:' +
                  fontColor +
                  ';'
                const url = text
                  ? require('@assets/img/comm_qy_checked.png')
                  : require('@assets/img/comm_qy_uncheck.png')

                if (
                  window.CloundEntid == '236' &&
                  data.moduleno == '1228' &&
                  it.fieldname == 'release' &&
                  !text
                )
                {
                  /// 联升 访客记录特殊修改
                  return (
                    <div style={style}>
                      <van-button
                        type="info"
                        size="small"
                        on-click={() => this.b4lianShengFX(row)}
                      >
                        确认放行
                      </van-button>
                    </div>
                  )
                } else
                {
                  return (
                    <div style={style}>
                      <img src={url} alt="" style="width:20px;height:20px;" />
                    </div>
                  )
                }
              }
            } else
            {
              // 文本
              it.renderBodyCell = ({ row, column, rowIndex }, h) => {
                const text = row[column.field]
                const bgcolor = row.v8_rgb_color_field
                  ? row.v8_rgb_color_field
                  : '#ffffff'
                const fontColor = row.v8_rgb_font_color
                  ? row.v8_rgb_font_color
                  : '#000000d9'
                const style =
                  'height: 100%;  align-items: center;width: 100%;padding:10px; font-size:' +
                  this.pageinfo.fontsize +
                  'px;text-align:' +
                  fieldvalue_align +
                  '; background:' +
                  bgcolor +
                  ';color:' +
                  fontColor +
                  ';'
                return <div style={style}>{text}</div>
              }
            }
            // 是否显示处理异常列
            if (it.type == 'btn')
            {
              it.renderBodyCell = ({ row, column, rowIndex }, h) => {
                const show_err_action_btn = row.show_err_action_btn
                const bgcolor = row.v8_rgb_color_field
                  ? row.v8_rgb_color_field
                  : '#ffffff'
                const fontColor = row.v8_rgb_font_color
                  ? row.v8_rgb_font_color
                  : '#000000d9'
                const style =
                  'height: 100%;  align-items: center;width: 100%;padding:10px; font-size: 14px;text-align:' +
                  fieldvalue_align +
                  '; background:' +
                  bgcolor +
                  ';color:' +
                  fontColor +
                  ';' +
                  ' display: flex; align-items: center; justify-content: center;'
                if (show_err_action_btn)
                {
                  return (
                    <div style={style}>
                      <van-button
                        type="info"
                        size="small"
                        on-click={() => this.checkUrlToGo(row)}
                      >
                        {this.err_action_btn_caption}
                      </van-button>
                    </div>
                  )
                } else if (it.showDetail)
                {
                  return (
                    <div style={style}>
                      <van-button
                        type="info"
                        size="small"
                        on-click={() => this.checkDetail(row)}
                      >
                        {'明细'}
                      </van-button>
                    </div>
                  )
                } else
                {
                  return <div style={style}> </div>
                }
              }
            }
          })
          // console.log(this.scrollWidth, 'scrollWidthscrollWidthscrollWidth');
          // console.log(this.thList, 'this.thList');
          this.tableData = JSON.parse(JSON.stringify(this.valueData))
          // 改造数据结构
          this.tableData.forEach((it, idx) => {
            it.serial = idx + 1
          })

          // 如果表格启用汇总
          if (this.pageinfo.openfooter)
          {
            this.totalData = [{ serial: '汇总' }]
            this.thList.forEach(it => {
              if (it.fieldname != 'serial')
              {
                if (it.gridwith && it.footerkind != 'skNone')
                {
                  let result = ''
                  const values = this.tableData.map(item =>
                    parseFloat(item[it.fieldname])
                  )
                  if (!values.every(value => isNaN(value)))
                  {
                    switch (it.footerkind)
                    {
                      case 'skAverage':
                        result = this.computedAverage(values)
                        break
                      case 'skCount':
                        result = this.computedCount(values)
                        break
                      case 'skMax':
                        result = this.computedMax(values)
                        break
                      case 'skMin':
                        result = this.computedMin(values)
                        break
                      case 'skSum':
                        let tol = this.computedSum(values)
                        result = Math.round(tol * 100) / 100
                        break
                    }
                    result = String(result)
                    const dot = result.indexOf('.')
                    if (dot > -1)
                    {
                      result = result.slice(0, dot + 3)
                    }
                  }
                  // this.totalData.push(result)
                  this.totalData[0][it.fieldname] = result
                } else
                {
                  if (it.gridwith && it.gridwith != 0)
                  {
                    // this.totalData.push('')
                    this.totalData[0][it.fieldname] = ''
                  }
                }
              }
            })
            // console.log(this.totalData, 'this.totalData');
          }
          this.ini = JSON.parse(JSON.stringify(this.tableData))
          this.ini2 = JSON.parse(JSON.stringify(this.totalData))
        }
      })
    },
    checkUrlToGo (row) { },
    b4lianShengFX (row) { },
    // 表格body合并单元格
    mergeCells ({ row, column, rowIndex }) {
      // 只处理前n-1列的合并
      if (this.mergedLeftFieldlist.includes(column.field))
      {
        const prevRow = this.tableData[rowIndex - 1]
        let nextRow = this.tableData[rowIndex + 1]
        let currentKey = this.getMergeKey(this.mergedLeftFieldlist, row)
        // 判断是否为新组合的起始行
        if (!prevRow || this.getMergeKey(this.mergedLeftFieldlist, prevRow) !== currentKey)
        {
          let rowspan = 1
          // 计算相同组合的行数
          while (nextRow && this.getMergeKey(this.mergedLeftFieldlist, nextRow) === currentKey)
          {
            rowspan++
            nextRow = this.tableData[rowIndex + rowspan]
          }
          return { rowspan, colspan: 1 }
        }
        return { rowspan: 0, colspan: 0 }
      } else if ([this.mergedRightFieldlist[this.mergedRightFieldlist.length - 1]].includes(column.field))
      {
        // 处理最后一列的合并
        const currentKey = this.getMergeKey(this.mergedRightFieldlist, row)
        const prevRow = this.tableData[rowIndex - 1]
        let nextRow = this.tableData[rowIndex + 1]
        // 判断是否为新组合的起始行
        if (!prevRow || this.getMergeKey(this.mergedRightFieldlist, prevRow) !== currentKey)
        {
          let rowspan = 1
          // 计算相同组合的行数
          while (nextRow && this.getMergeKey(this.mergedRightFieldlist, nextRow) === currentKey)
          {
            rowspan++
            nextRow = this.tableData[rowIndex + rowspan]
          }
          return { rowspan, colspan: 1 }
        }
        return { rowspan: 0, colspan: 0 }
      }
    },
    // 根据字段名数组获取合并单元格组合值
    getMergeKey (fieldList, row) {
      let Key = ''
      fieldList.forEach((fl, i) => {
        if (row)
        {
          Key += row[fl]
        }
        if (i < fieldList.length - 1)
        { // 除了最后一个元素外，都加上'-' 
          if (Key)
          {
            Key += '-'
          }
        }
      });
      return Key
    },
    // tab切换事件：
    changeActive (name, title) {
      // this.onRefreshAwait()
      // console.log(name, 'changeActive', this.activeName);
      this.getFixedAssetsPdMasterdata()
    },
    // 平均值
    computedAverage (arr) {
      return Math.floor((sum(arr) * 1000) / arr.length) / 1000
    },
    // 整数
    computedCount (arr) {
      return arr.length
    },
    // 最大值
    computedMax (arr) {
      return Math.max(...arr)
    },
    // 最小值
    computedMin (arr) {
      return Math.min(...arr)
    },
    // 求和
    computedSum (arr) {
      return arr.reduce((prev, curr) => {
        const value = Number(curr)
        if (!isNaN(value))
        {
          return prev + curr
        } else
        {
          return prev
        }
      }, 0)
    },
    // 返回
    onClickLeft () {
      if (this.$route.query.from == 'home')
      {
        this.$router.push('/home')
      } else
      {
        this.$router.push('/personCen')
      }
    },
  }
}
</script>

<style lang="less" scoped>
.IA_fixedAssetInventory {
  height: 100vh;
  overflow: hidden;
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
  }
  .content {
    // overflow: auto;
    margin-top: 1.22667rem;
    height: calc(100% - 92px);
    .van-tabs {
      height: 90px;
    }
    .table_content {
      height: calc(100% - 90px);
      .vue-table-root {
        /deep/.ve-table {
          height: 100%;
          .ve-table-container {
            .ve-table-content-wrapper {
              .ve-table-content {
                .ve-table-header {
                  .ve-table-header-tr {
                    height: 80px;
                    .ve-table-header-th {
                      font-size: var(--header_fontsize); // 28px;
                      font-weight: var(--header_isbold); // bold;
                      white-space: pre-wrap;
                    }
                  }
                }
                .ve-table-body {
                  .ve-table-body-tr {
                    .ve-table-body-td {
                      padding: 0 !important;
                    }
                    .merged-cell {
                      div {
                        display: flex;
                        justify-content: center;
                      }
                    }
                  }
                }
                .ve-table-footer {
                  .ve-table-footer-tr {
                    height: 80px;

                    .ve-table-footer-td {
                      font-size: 28px;
                      background-color: rgb(255, 211, 184);
                    }
                  }
                }
              }
            }
          }
        }
      }
      .auto_table {
        height: 100%;
        overflow: auto;
        .table {
          width: 100%;
          border-spacing: 0px;
          tr {
            td:nth-child(1) {
              border-left: 2px solid #dcdfe6;
            }
            th,
            td {
              padding: 6px 10px;
              text-align: center;
              border-bottom: 2px solid #dcdfe6;
              border-right: 2px solid #dcdfe6;
              .comm_box {
                .boolean_box {
                  .van-checkbox {
                    justify-content: center;
                    /deep/.van-checkbox__icon--checked {
                      .van-icon {
                        color: #fff !important;
                        background-color: #1989fa !important;
                        border-color: #1989fa !important;
                      }
                    }
                    /deep/.van-checkbox__icon--disabled .van-icon {
                      background-color: #fff;
                    }
                  }
                }
              }
            }
          }
          .top {
            position: sticky;
            top: 0;
            font-size: 28px;
            background: #e9f3fd;
            height: 64px;
            th:nth-child(1) {
              border-left: 2px solid #dcdfe6;
            }
          }
          .cont {
            height: 64px;
            font-size: 24px;
          }
          .cont:nth-child(2n-1) {
            background: #f5f5f5;
          }
        }
      }
    }
  }
}
</style>